import { Resource } from "./useResources";
import { useState } from "react";
import { Button, Card, Popover, Stack, Title } from "@introist/react-foundation/v2";
import { ResourceSelector } from "./ResourceSelector";
import { Skeletons } from "../../../components/molecules";
import { ResourceCard } from "./ResourceCard";

export const ResourceCollection = ({
  resources,
  onAdd,
  onRemove,
  title
}: {
  resources?: Resource[];
  onAdd?: (resource: Resource) => unknown;
  onRemove?: (resource: Resource) => unknown;
  title?: string;
}) => {
  const [ref, setRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  if (resources === undefined) return <Skeletons.Block height={25} width={100} />;

  return (
    <div ref={setRef}>
      <Button
        variant={open ? "outlined" : "blended"}
        size="small"
        onClick={() => setOpen(!open)}
        startIcon="hardDrive"
      >
        {resources.length > 0
          ? `${resources.length} resource${resources.length > 1 ? "s" : ""}`
          : "No resources"}
      </Button>
      <Popover
        referenceElement={ref}
        open={open}
        onClose={() => setOpen(false)}
        closeOnContentClick={false}
        elevation="mercury"
      >
        <Card style={{ padding: "var(--spacing-medium)" }}>
          <Stack vertical>
            {title && <Title>{title}</Title>}
            <Stack vertical gap="small">
              {resources.map(r => (
                <ResourceCard
                  resource={r}
                  onRemove={onRemove ? () => onRemove(r) : undefined}
                  confirmRemoval
                />
              ))}
            </Stack>
            {onAdd && <ResourceSelector onSelect={onAdd} />}
          </Stack>
        </Card>
      </Popover>
    </div>
  );
};
